import React from "react";

const Loading = ({ loading, children }) => {
  return (
    <div className="container-fluid">
      <div className="position-absolute top-50 start-50 translate-middle">
        <div
          className="spinner-border fs-1 fw-bold text-primary"
          style={{ width: "10rem", height: "10rem" }}
          role="status"
        >
          <span className="visually-hidden">Loading ...</span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
